"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeSmoother = void 0;
var composer_types_1 = require("../composers/composer-types");
var lowest_value_composer_1 = require("../composers/lowest-value-composer");
var CompositeSmoother = /** @class */ (function () {
    function CompositeSmoother(smoothers, composerType) {
        this.smoothers = smoothers;
        this.composer = this.createComposer(composerType);
    }
    CompositeSmoother.prototype.getValue = function () {
        var _a;
        var estimates = this.smoothers.map(function (s) {
            return s.getValue();
        });
        return (_a = this.composer).compose.apply(_a, estimates);
    };
    CompositeSmoother.prototype.sample = function (newSample) {
        this.smoothers.forEach(function (smoother) {
            smoother.sample(newSample);
        });
    };
    CompositeSmoother.prototype.clear = function () {
        this.smoothers.forEach(function (smoother) {
            smoother.clear();
        });
    };
    CompositeSmoother.prototype.createComposer = function (composerType) {
        switch (composerType) {
            case composer_types_1.ComposerType.LOWEST_VALUE:
                return new lowest_value_composer_1.LowestValueComposer();
        }
    };
    return CompositeSmoother;
}());
exports.CompositeSmoother = CompositeSmoother;
